export default "__VITE_ASSET__ZtLFTk$Y__"